import React from "react"
import Login from "../Login/Login";
import {Button, Col, Container, Row} from "react-bootstrap";
import AllPostsAdmin from "../AllPostsAdmin/AllPostsAdmin";
import NewPostsAdmin from "../NewPostsAdmin/NewPostsAdmin";
import {getCategories} from "../../api/api_category";
import {getPostOptions} from "../../api/api_post_options";

export default class Admin extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loggedIn: false,
            currentPage: null
        }

        this.allCategories = []
        this.allPostOptions = []

        this.loggedInHandler = this.loggedInHandler.bind(this)
        this.goTo = this.goTo.bind(this)
    }

    componentDidMount() {
        //remove me
        // this.loggedInHandler()

        Promise.all([getCategories({'order': {'name': 'asc'}})]).then((promisesResults) => {
            const [categories] = promisesResults
            this.allCategories = categories['hydra:member']
        })

        Promise.all([getPostOptions({'order': {'name': 'asc'}})]).then((promisesResults) => {
            const [options] = promisesResults
            this.allPostOptions = options['hydra:member']
        })
    }

    loggedInHandler() {
        this.setState({loggedIn: true})
    }

    goTo(e) {
        this.setState({currentPage: e.target.dataset.pagename})
        // this.props.history.push(e.target.dataset.url)
    }

    render() {
        console.log('loggedIn', this.state.loggedIn)
        console.log('currentPage', this.state.currentPage)
        if (!this.state.loggedIn) {
            return <Login loggedInHandler={this.loggedInHandler}/>
        }

        let displayedPage=''
        let buttonAllPosts='outline-primary'
        let buttonNewPosts='outline-warning'
        if (this.state.currentPage === 'all_posts') {
            displayedPage=<AllPostsAdmin allCategories={this.allCategories} allPostOptions={this.allPostOptions}/>
            buttonAllPosts='primary'
        } else if (this.state.currentPage === 'new_posts') {
            displayedPage=<NewPostsAdmin allCategories={this.allCategories} allPostOptions={this.allPostOptions}/>
            buttonNewPosts='warning'
        }

        return <Container>
            <Row>
                <Col md={1}>
                    <h2>HalfGag Admin</h2>
                    <p>
                        <Button variant={buttonAllPosts} type="submit" data-pagename="all_posts" data-url="all-posts-admin" onClick={this.goTo}>
                            All Posts
                        </Button>
                    </p>
                    <p>
                        <Button variant={buttonNewPosts} type="submit" data-pagename="new_posts" data-url="new-posts-admin" onClick={this.goTo}>
                            New Posts
                        </Button>
                    </p>
                </Col>
                <Col>
                    {displayedPage}
                </Col>
            </Row>
        </Container>
    }
}